/**
 * Collapse Component
 * Open Collapse by clicking collapse header
 * To hide child content and show content after clicking the header
 */
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Glyph from 'kepler/lib/components/Glyph';

class CollapseSegment extends Component {
  // Using CSSTransitionGroup to have open and close animation
  static renderWithAnimation(component) {
    return (
      <ReactCSSTransitionGroup
        transitionName="collapse"
        transitionEnterTimeout={400}
        transitionLeaveTimeout={400}
      >
        {component}
      </ReactCSSTransitionGroup>
    );
  }

  // Bind Click Event Method for Collapse content.
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  // Handle Key press for accessing
  handleKeyPress(event) {
    if (event.which === 13) {
      this.toggleCollapse();
    }
  }

  getAccordionHeaderClass() {
    return classNames({
      'collapse-header': !this.getOpenControl(),
      'collapse-header collapse-header--active': this.getOpenControl(),
    });
  }

  // Customer the open or close style by
  getOpenControl() {
    if (typeof this.props.open === 'boolean') {
      return this.props.open;
    }
    return this.state.open;
  }

  getCollapseClass() {
    return classNames({
      'collapse-content': true,
      displayed: true,
      display_hidden: !this.getOpenControl(),
    });
  }

  // Toggle the Collapse content
  toggleCollapse(event) {
    this.props.onClick(event);
    this.setState({
      open: !this.state.open,
    });
  }

  // Render Collapse Content; toggle header to show/hide
  renderCollapseAnimation() {
    return (
      <div className={this.getCollapseClass()}>
        <div className="collaspe-content-children ">{this.props.children}</div>
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <div // eslint-disable-line jsx-a11y/no-static-element-interactions
          className={this.getAccordionHeaderClass()}
          role="tab"
          tabIndex="0"
          onClick={(e) => this.toggleCollapse(e)}
          onKeyPress={(event) => this.handleKeyPress(event)}
        >
          <div className="collapse-header-text">{this.props.header}</div>
          <Glyph icon="icon-arrow-down-small" className="collapse-accordion-icon" aria-hidden="true" />
        </div>
        {this.renderCollapseAnimation()}
      </div>
    );
  }
}

// CollapseSegment Props Types.
CollapseSegment.propTypes = {
  header: PropTypes.string,
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  open: PropTypes.bool,
};

// CollapseSegment Props default values.
CollapseSegment.defaultProps = {
  header: '',
  className: 'collapse-container',
  onClick: () => {},
  open: undefined, // Customer display logic
};

export default CollapseSegment;
